(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GlucoseSystemCodes = {
  blood: 'http://loinc.org|15074-8',
  // Laboratory
  capillaryBloodByGlucometer: 'http://loinc.org|14743-9',
  // Glucometer
  bodyFluid: 'http://loinc.org|14745-4' // Continuous Glucose Monitoring (CGM) Device

};

function getGlucoseMeasurer(glucoseSystem) {
  switch (glucoseSystem) {
    case 'blood':
      return t('ehr', 'Laboratory');

    case 'capillaryBloodByGlucometer':
      return t('ehr', 'Glucometer');

    case 'bodyFluid':
      return t('ehr', 'CGM (Continuous Glucose Monitoring) Device');

    default:
      return t('ehr', 'Unknown');
  }
}

function getGlucoseSystemDisplay(glucoseSystem) {
  switch (glucoseSystem) {
    case 'blood':
      return 'Glucose [Moles/volume] in Blood';

    case 'capillaryBloodByGlucometer':
      return 'Glucose [Moles/volume] in Capillary blood by Glucometer';

    case 'bodyFluid':
      return 'Glucose [Moles/volume] in Body fluid';

    default:
      return 'Unknown';
  }
}

export { GlucoseSystemCodes, getGlucoseMeasurer, getGlucoseSystemDisplay };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GlucoseSystemCodes, "GlucoseSystemCodes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/lib/GlucoseSystemCodes.js");
  reactHotLoader.register(getGlucoseMeasurer, "getGlucoseMeasurer", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/lib/GlucoseSystemCodes.js");
  reactHotLoader.register(getGlucoseSystemDisplay, "getGlucoseSystemDisplay", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/lib/GlucoseSystemCodes.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();